"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
require("core-js/modules/es6.array.filter.js");
var _gAxios = _interopRequireWildcard(require("@gravity/g-axios"));
var _get = _interopRequireDefault(require("lodash/get"));
var _constants = require("./constants");
var _helper = _interopRequireDefault(require("./helper"));
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_144agggqf5() {
  var path = "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/actions.js";
  var hash = "419c10d69377096a29e5687214893420599e7299";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1340795087/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/productList/lib/actions.js",
    statementMap: {
      "0": {
        start: {
          line: 7,
          column: 35
        },
        end: {
          line: 9,
          column: 2
        }
      },
      "1": {
        start: {
          line: 7,
          column: 42
        },
        end: {
          line: 9,
          column: 1
        }
      },
      "2": {
        start: {
          line: 11,
          column: 27
        },
        end: {
          line: 14,
          column: 2
        }
      },
      "3": {
        start: {
          line: 11,
          column: 45
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "4": {
        start: {
          line: 16,
          column: 35
        },
        end: {
          line: 29,
          column: 2
        }
      },
      "5": {
        start: {
          line: 22,
          column: 7
        },
        end: {
          line: 29,
          column: 1
        }
      },
      "6": {
        start: {
          line: 31,
          column: 36
        },
        end: {
          line: 44,
          column: 2
        }
      },
      "7": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 44,
          column: 1
        }
      },
      "8": {
        start: {
          line: 46,
          column: 37
        },
        end: {
          line: 67,
          column: 2
        }
      },
      "9": {
        start: {
          line: 56,
          column: 6
        },
        end: {
          line: 67,
          column: 1
        }
      },
      "10": {
        start: {
          line: 69,
          column: 30
        },
        end: {
          line: 72,
          column: 2
        }
      },
      "11": {
        start: {
          line: 69,
          column: 39
        },
        end: {
          line: 72,
          column: 1
        }
      },
      "12": {
        start: {
          line: 74,
          column: 27
        },
        end: {
          line: 76,
          column: 2
        }
      },
      "13": {
        start: {
          line: 74,
          column: 34
        },
        end: {
          line: 76,
          column: 1
        }
      },
      "14": {
        start: {
          line: 83,
          column: 18
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "15": {
        start: {
          line: 83,
          column: 39
        },
        end: {
          line: 85,
          column: 1
        }
      },
      "16": {
        start: {
          line: 84,
          column: 2
        },
        end: {
          line: 84,
          column: 44
        }
      },
      "17": {
        start: {
          line: 87,
          column: 16
        },
        end: {
          line: 87,
          column: 44
        }
      },
      "18": {
        start: {
          line: 87,
          column: 25
        },
        end: {
          line: 87,
          column: 44
        }
      },
      "19": {
        start: {
          line: 89,
          column: 22
        },
        end: {
          line: 91,
          column: 1
        }
      },
      "20": {
        start: {
          line: 89,
          column: 40
        },
        end: {
          line: 91,
          column: 1
        }
      },
      "21": {
        start: {
          line: 90,
          column: 2
        },
        end: {
          line: 90,
          column: 50
        }
      },
      "22": {
        start: {
          line: 93,
          column: 29
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "23": {
        start: {
          line: 93,
          column: 85
        },
        end: {
          line: 101,
          column: 1
        }
      },
      "24": {
        start: {
          line: 94,
          column: 2
        },
        end: {
          line: 100,
          column: 4
        }
      },
      "25": {
        start: {
          line: 103,
          column: 22
        },
        end: {
          line: 103,
          column: 24
        }
      },
      "26": {
        start: {
          line: 105,
          column: 25
        },
        end: {
          line: 105,
          column: 81
        }
      },
      "27": {
        start: {
          line: 105,
          column: 39
        },
        end: {
          line: 105,
          column: 81
        }
      },
      "28": {
        start: {
          line: 107,
          column: 29
        },
        end: {
          line: 113,
          column: 1
        }
      },
      "29": {
        start: {
          line: 108,
          column: 16
        },
        end: {
          line: 108,
          column: 44
        }
      },
      "30": {
        start: {
          line: 109,
          column: 2
        },
        end: {
          line: 111,
          column: 3
        }
      },
      "31": {
        start: {
          line: 110,
          column: 4
        },
        end: {
          line: 110,
          column: 20
        }
      },
      "32": {
        start: {
          line: 112,
          column: 2
        },
        end: {
          line: 112,
          column: 60
        }
      },
      "33": {
        start: {
          line: 112,
          column: 36
        },
        end: {
          line: 112,
          column: 58
        }
      },
      "34": {
        start: {
          line: 122,
          column: 21
        },
        end: {
          line: 214,
          column: 1
        }
      },
      "35": {
        start: {
          line: 132,
          column: 5
        },
        end: {
          line: 214,
          column: 1
        }
      },
      "36": {
        start: {
          line: 140,
          column: 4
        },
        end: {
          line: 140,
          column: 88
        }
      },
      "37": {
        start: {
          line: 142,
          column: 4
        },
        end: {
          line: 147,
          column: 5
        }
      },
      "38": {
        start: {
          line: 145,
          column: 8
        },
        end: {
          line: 145,
          column: 97
        }
      },
      "39": {
        start: {
          line: 148,
          column: 26
        },
        end: {
          line: 152,
          column: 3
        }
      },
      "40": {
        start: {
          line: 150,
          column: 6
        },
        end: {
          line: 150,
          column: 94
        }
      },
      "41": {
        start: {
          line: 154,
          column: 33
        },
        end: {
          line: 154,
          column: 158
        }
      },
      "42": {
        start: {
          line: 155,
          column: 33
        },
        end: {
          line: 155,
          column: 83
        }
      },
      "43": {
        start: {
          line: 157,
          column: 2
        },
        end: {
          line: 165,
          column: 4
        }
      },
      "44": {
        start: {
          line: 167,
          column: 34
        },
        end: {
          line: 167,
          column: 117
        }
      },
      "45": {
        start: {
          line: 169,
          column: 20
        },
        end: {
          line: 175,
          column: 58
        }
      },
      "46": {
        start: {
          line: 175,
          column: 32
        },
        end: {
          line: 175,
          column: 53
        }
      },
      "47": {
        start: {
          line: 177,
          column: 21
        },
        end: {
          line: 177,
          column: 83
        }
      },
      "48": {
        start: {
          line: 179,
          column: 2
        },
        end: {
          line: 181,
          column: 3
        }
      },
      "49": {
        start: {
          line: 180,
          column: 4
        },
        end: {
          line: 180,
          column: 16
        }
      },
      "50": {
        start: {
          line: 183,
          column: 2
        },
        end: {
          line: 183,
          column: 35
        }
      },
      "51": {
        start: {
          line: 185,
          column: 2
        },
        end: {
          line: 213,
          column: 7
        }
      },
      "52": {
        start: {
          line: 187,
          column: 6
        },
        end: {
          line: 187,
          column: 74
        }
      },
      "53": {
        start: {
          line: 188,
          column: 6
        },
        end: {
          line: 205,
          column: 7
        }
      },
      "54": {
        start: {
          line: 189,
          column: 22
        },
        end: {
          line: 189,
          column: 61
        }
      },
      "55": {
        start: {
          line: 190,
          column: 30
        },
        end: {
          line: 190,
          column: 100
        }
      },
      "56": {
        start: {
          line: 191,
          column: 8
        },
        end: {
          line: 203,
          column: 10
        }
      },
      "57": {
        start: {
          line: 204,
          column: 8
        },
        end: {
          line: 204,
          column: 29
        }
      },
      "58": {
        start: {
          line: 206,
          column: 6
        },
        end: {
          line: 206,
          column: 21
        }
      },
      "59": {
        start: {
          line: 209,
          column: 6
        },
        end: {
          line: 209,
          column: 74
        }
      },
      "60": {
        start: {
          line: 210,
          column: 6
        },
        end: {
          line: 210,
          column: 37
        }
      },
      "61": {
        start: {
          line: 211,
          column: 6
        },
        end: {
          line: 211,
          column: 102
        }
      },
      "62": {
        start: {
          line: 212,
          column: 6
        },
        end: {
          line: 212,
          column: 22
        }
      },
      "63": {
        start: {
          line: 216,
          column: 17
        },
        end: {
          line: 249,
          column: 1
        }
      },
      "64": {
        start: {
          line: 216,
          column: 54
        },
        end: {
          line: 249,
          column: 1
        }
      },
      "65": {
        start: {
          line: 218,
          column: 2
        },
        end: {
          line: 218,
          column: 41
        }
      },
      "66": {
        start: {
          line: 220,
          column: 16
        },
        end: {
          line: 220,
          column: 206
        }
      },
      "67": {
        start: {
          line: 221,
          column: 2
        },
        end: {
          line: 223,
          column: 3
        }
      },
      "68": {
        start: {
          line: 222,
          column: 4
        },
        end: {
          line: 222,
          column: 61
        }
      },
      "69": {
        start: {
          line: 224,
          column: 2
        },
        end: {
          line: 248,
          column: 7
        }
      },
      "70": {
        start: {
          line: 230,
          column: 6
        },
        end: {
          line: 241,
          column: 7
        }
      },
      "71": {
        start: {
          line: 231,
          column: 8
        },
        end: {
          line: 239,
          column: 10
        }
      },
      "72": {
        start: {
          line: 240,
          column: 8
        },
        end: {
          line: 240,
          column: 29
        }
      },
      "73": {
        start: {
          line: 242,
          column: 6
        },
        end: {
          line: 242,
          column: 21
        }
      },
      "74": {
        start: {
          line: 245,
          column: 6
        },
        end: {
          line: 245,
          column: 37
        }
      },
      "75": {
        start: {
          line: 246,
          column: 6
        },
        end: {
          line: 246,
          column: 102
        }
      },
      "76": {
        start: {
          line: 247,
          column: 6
        },
        end: {
          line: 247,
          column: 22
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 7,
            column: 35
          },
          end: {
            line: 7,
            column: 36
          }
        },
        loc: {
          start: {
            line: 7,
            column: 42
          },
          end: {
            line: 9,
            column: 1
          }
        },
        line: 7
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 27
          },
          end: {
            line: 11,
            column: 28
          }
        },
        loc: {
          start: {
            line: 11,
            column: 45
          },
          end: {
            line: 14,
            column: 1
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 16,
            column: 35
          },
          end: {
            line: 16,
            column: 36
          }
        },
        loc: {
          start: {
            line: 22,
            column: 7
          },
          end: {
            line: 29,
            column: 1
          }
        },
        line: 22
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 31,
            column: 36
          },
          end: {
            line: 31,
            column: 37
          }
        },
        loc: {
          start: {
            line: 37,
            column: 6
          },
          end: {
            line: 44,
            column: 1
          }
        },
        line: 37
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 46,
            column: 37
          },
          end: {
            line: 46,
            column: 38
          }
        },
        loc: {
          start: {
            line: 56,
            column: 6
          },
          end: {
            line: 67,
            column: 1
          }
        },
        line: 56
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 69,
            column: 30
          },
          end: {
            line: 69,
            column: 31
          }
        },
        loc: {
          start: {
            line: 69,
            column: 39
          },
          end: {
            line: 72,
            column: 1
          }
        },
        line: 69
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 74,
            column: 27
          },
          end: {
            line: 74,
            column: 28
          }
        },
        loc: {
          start: {
            line: 74,
            column: 34
          },
          end: {
            line: 76,
            column: 1
          }
        },
        line: 74
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 83,
            column: 18
          },
          end: {
            line: 83,
            column: 19
          }
        },
        loc: {
          start: {
            line: 83,
            column: 39
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 83
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 83,
            column: 39
          },
          end: {
            line: 83,
            column: 40
          }
        },
        loc: {
          start: {
            line: 83,
            column: 51
          },
          end: {
            line: 85,
            column: 1
          }
        },
        line: 83
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 87,
            column: 16
          },
          end: {
            line: 87,
            column: 17
          }
        },
        loc: {
          start: {
            line: 87,
            column: 25
          },
          end: {
            line: 87,
            column: 44
          }
        },
        line: 87
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 89,
            column: 22
          },
          end: {
            line: 89,
            column: 23
          }
        },
        loc: {
          start: {
            line: 89,
            column: 40
          },
          end: {
            line: 91,
            column: 1
          }
        },
        line: 89
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 89,
            column: 40
          },
          end: {
            line: 89,
            column: 41
          }
        },
        loc: {
          start: {
            line: 89,
            column: 52
          },
          end: {
            line: 91,
            column: 1
          }
        },
        line: 89
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 93,
            column: 29
          },
          end: {
            line: 93,
            column: 30
          }
        },
        loc: {
          start: {
            line: 93,
            column: 85
          },
          end: {
            line: 101,
            column: 1
          }
        },
        line: 93
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 93,
            column: 85
          },
          end: {
            line: 93,
            column: 86
          }
        },
        loc: {
          start: {
            line: 93,
            column: 97
          },
          end: {
            line: 101,
            column: 1
          }
        },
        line: 93
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 105,
            column: 25
          },
          end: {
            line: 105,
            column: 26
          }
        },
        loc: {
          start: {
            line: 105,
            column: 39
          },
          end: {
            line: 105,
            column: 81
          }
        },
        line: 105
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 107,
            column: 29
          },
          end: {
            line: 107,
            column: 30
          }
        },
        loc: {
          start: {
            line: 107,
            column: 55
          },
          end: {
            line: 113,
            column: 1
          }
        },
        line: 107
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 112,
            column: 25
          },
          end: {
            line: 112,
            column: 26
          }
        },
        loc: {
          start: {
            line: 112,
            column: 36
          },
          end: {
            line: 112,
            column: 58
          }
        },
        line: 112
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 122,
            column: 21
          },
          end: {
            line: 122,
            column: 22
          }
        },
        loc: {
          start: {
            line: 132,
            column: 5
          },
          end: {
            line: 214,
            column: 1
          }
        },
        line: 132
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 132,
            column: 5
          },
          end: {
            line: 132,
            column: 6
          }
        },
        loc: {
          start: {
            line: 132,
            column: 17
          },
          end: {
            line: 214,
            column: 1
          }
        },
        line: 132
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 144,
            column: 6
          },
          end: {
            line: 144,
            column: 7
          }
        },
        loc: {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 145,
            column: 97
          }
        },
        line: 145
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 149,
            column: 4
          },
          end: {
            line: 149,
            column: 5
          }
        },
        loc: {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 150,
            column: 94
          }
        },
        line: 150
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 175,
            column: 11
          },
          end: {
            line: 175,
            column: 12
          }
        },
        loc: {
          start: {
            line: 175,
            column: 32
          },
          end: {
            line: 175,
            column: 53
          }
        },
        line: 175
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 186,
            column: 10
          },
          end: {
            line: 186,
            column: 11
          }
        },
        loc: {
          start: {
            line: 186,
            column: 22
          },
          end: {
            line: 207,
            column: 5
          }
        },
        line: 186
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 208,
            column: 11
          },
          end: {
            line: 208,
            column: 12
          }
        },
        loc: {
          start: {
            line: 208,
            column: 23
          },
          end: {
            line: 213,
            column: 5
          }
        },
        line: 208
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 216,
            column: 17
          },
          end: {
            line: 216,
            column: 18
          }
        },
        loc: {
          start: {
            line: 216,
            column: 54
          },
          end: {
            line: 249,
            column: 1
          }
        },
        line: 216
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 216,
            column: 54
          },
          end: {
            line: 216,
            column: 55
          }
        },
        loc: {
          start: {
            line: 216,
            column: 66
          },
          end: {
            line: 249,
            column: 1
          }
        },
        line: 216
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 229,
            column: 10
          },
          end: {
            line: 229,
            column: 11
          }
        },
        loc: {
          start: {
            line: 229,
            column: 22
          },
          end: {
            line: 243,
            column: 5
          }
        },
        line: 229
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 244,
            column: 11
          },
          end: {
            line: 244,
            column: 12
          }
        },
        loc: {
          start: {
            line: 244,
            column: 23
          },
          end: {
            line: 248,
            column: 5
          }
        },
        line: 244
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 87,
            column: 25
          },
          end: {
            line: 87,
            column: 44
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 87,
            column: 25
          },
          end: {
            line: 87,
            column: 30
          }
        }, {
          start: {
            line: 87,
            column: 34
          },
          end: {
            line: 87,
            column: 44
          }
        }],
        line: 87
      },
      "1": {
        loc: {
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 109,
            column: 2
          },
          end: {
            line: 111,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 109
      },
      "2": {
        loc: {
          start: {
            line: 131,
            column: 2
          },
          end: {
            line: 131,
            column: 27
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 131,
            column: 25
          },
          end: {
            line: 131,
            column: 27
          }
        }],
        line: 131
      },
      "3": {
        loc: {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 88
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 140,
            column: 56
          },
          end: {
            line: 140,
            column: 83
          }
        }, {
          start: {
            line: 140,
            column: 86
          },
          end: {
            line: 140,
            column: 88
          }
        }],
        line: 140
      },
      "4": {
        loc: {
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 140,
            column: 4
          },
          end: {
            line: 140,
            column: 22
          }
        }, {
          start: {
            line: 140,
            column: 26
          },
          end: {
            line: 140,
            column: 53
          }
        }],
        line: 140
      },
      "5": {
        loc: {
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 142,
            column: 4
          },
          end: {
            line: 142,
            column: 18
          }
        }, {
          start: {
            line: 143,
            column: 4
          },
          end: {
            line: 147,
            column: 5
          }
        }],
        line: 142
      },
      "6": {
        loc: {
          start: {
            line: 145,
            column: 8
          },
          end: {
            line: 145,
            column: 97
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 145,
            column: 36
          },
          end: {
            line: 145,
            column: 86
          }
        }, {
          start: {
            line: 145,
            column: 89
          },
          end: {
            line: 145,
            column: 97
          }
        }],
        line: 145
      },
      "7": {
        loc: {
          start: {
            line: 150,
            column: 6
          },
          end: {
            line: 150,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 150,
            column: 36
          },
          end: {
            line: 150,
            column: 89
          }
        }, {
          start: {
            line: 150,
            column: 92
          },
          end: {
            line: 150,
            column: 94
          }
        }],
        line: 150
      },
      "8": {
        loc: {
          start: {
            line: 154,
            column: 79
          },
          end: {
            line: 154,
            column: 157
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 154,
            column: 127
          },
          end: {
            line: 154,
            column: 144
          }
        }, {
          start: {
            line: 154,
            column: 147
          },
          end: {
            line: 154,
            column: 157
          }
        }],
        line: 154
      },
      "9": {
        loc: {
          start: {
            line: 154,
            column: 79
          },
          end: {
            line: 154,
            column: 124
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 154,
            column: 79
          },
          end: {
            line: 154,
            column: 92
          }
        }, {
          start: {
            line: 154,
            column: 96
          },
          end: {
            line: 154,
            column: 124
          }
        }],
        line: 154
      },
      "10": {
        loc: {
          start: {
            line: 167,
            column: 34
          },
          end: {
            line: 167,
            column: 117
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 167,
            column: 62
          },
          end: {
            line: 167,
            column: 112
          }
        }, {
          start: {
            line: 167,
            column: 115
          },
          end: {
            line: 167,
            column: 117
          }
        }],
        line: 167
      },
      "11": {
        loc: {
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 181,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 179,
            column: 2
          },
          end: {
            line: 181,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 179
      },
      "12": {
        loc: {
          start: {
            line: 188,
            column: 6
          },
          end: {
            line: 205,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 188,
            column: 6
          },
          end: {
            line: 205,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 188
      },
      "13": {
        loc: {
          start: {
            line: 188,
            column: 10
          },
          end: {
            line: 188,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 188,
            column: 10
          },
          end: {
            line: 188,
            column: 32
          }
        }, {
          start: {
            line: 188,
            column: 36
          },
          end: {
            line: 188,
            column: 57
          }
        }],
        line: 188
      },
      "14": {
        loc: {
          start: {
            line: 190,
            column: 30
          },
          end: {
            line: 190,
            column: 100
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 190,
            column: 66
          },
          end: {
            line: 190,
            column: 93
          }
        }, {
          start: {
            line: 190,
            column: 96
          },
          end: {
            line: 190,
            column: 100
          }
        }],
        line: 190
      },
      "15": {
        loc: {
          start: {
            line: 220,
            column: 41
          },
          end: {
            line: 220,
            column: 103
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 220,
            column: 89
          },
          end: {
            line: 220,
            column: 98
          }
        }, {
          start: {
            line: 220,
            column: 101
          },
          end: {
            line: 220,
            column: 103
          }
        }],
        line: 220
      },
      "16": {
        loc: {
          start: {
            line: 220,
            column: 41
          },
          end: {
            line: 220,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 220,
            column: 41
          },
          end: {
            line: 220,
            column: 54
          }
        }, {
          start: {
            line: 220,
            column: 58
          },
          end: {
            line: 220,
            column: 86
          }
        }],
        line: 220
      },
      "17": {
        loc: {
          start: {
            line: 220,
            column: 121
          },
          end: {
            line: 220,
            column: 204
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 220,
            column: 149
          },
          end: {
            line: 220,
            column: 199
          }
        }, {
          start: {
            line: 220,
            column: 202
          },
          end: {
            line: 220,
            column: 204
          }
        }],
        line: 220
      },
      "18": {
        loc: {
          start: {
            line: 221,
            column: 2
          },
          end: {
            line: 223,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 221,
            column: 2
          },
          end: {
            line: 223,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 221
      },
      "19": {
        loc: {
          start: {
            line: 221,
            column: 6
          },
          end: {
            line: 221,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 221,
            column: 6
          },
          end: {
            line: 221,
            column: 19
          }
        }, {
          start: {
            line: 221,
            column: 23
          },
          end: {
            line: 221,
            column: 57
          }
        }],
        line: 221
      },
      "20": {
        loc: {
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 230,
            column: 6
          },
          end: {
            line: 241,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 230
      },
      "21": {
        loc: {
          start: {
            line: 230,
            column: 10
          },
          end: {
            line: 230,
            column: 57
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 230,
            column: 10
          },
          end: {
            line: 230,
            column: 32
          }
        }, {
          start: {
            line: 230,
            column: 36
          },
          end: {
            line: 230,
            column: 57
          }
        }],
        line: 230
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "419c10d69377096a29e5687214893420599e7299"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_144agggqf5 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_144agggqf5();
cov_144agggqf5().s[0]++;
var getBeforeLoadSummaryAction = function getBeforeLoadSummaryAction() {
  cov_144agggqf5().f[0]++;
  cov_144agggqf5().s[1]++;
  return {
    type: _constants.ProductListActionTypes.PRODUCT_LIST_BEFORE_LOAD_SUMMARY
  };
};
cov_144agggqf5().s[2]++;
var getChangeTabAction = function getChangeTabAction(_ref) {
  var tabcode = _ref.tabcode;
  cov_144agggqf5().f[1]++;
  cov_144agggqf5().s[3]++;
  return {
    type: _constants.ProductListActionTypes.PRODUCT_LIST_CHANGE_TAB_SUCCESS,
    tabcode: tabcode
  };
};
cov_144agggqf5().s[4]++;
var getBeforeLoadProductAction = function getBeforeLoadProductAction(_ref2) {
  var tabCode = _ref2.tabCode,
    sectionCode = _ref2.sectionCode,
    sectionCriteria = _ref2.sectionCriteria,
    filterCriteria = _ref2.filterCriteria,
    isFilterChanged = _ref2.isFilterChanged;
  cov_144agggqf5().f[2]++;
  cov_144agggqf5().s[5]++;
  return {
    type: _constants.ProductListActionTypes.PRODUCT_LIST_BEFORE_LOAD_PRODUCTS,
    tabCode: tabCode,
    sectionCode: sectionCode,
    sectionCriteria: sectionCriteria,
    filterCriteria: filterCriteria,
    isFilterChanged: isFilterChanged
  };
};
cov_144agggqf5().s[6]++;
var getLoadSummarySuccessAction = function getLoadSummarySuccessAction(data, layoutOptions, seasonHighlighted, tabDatas, config) {
  cov_144agggqf5().f[3]++;
  cov_144agggqf5().s[7]++;
  return {
    type: _constants.ProductListActionTypes.PRODUCT_LIST_LOAD_SUMMARY_SUCCESS,
    data: data,
    layoutOptions: layoutOptions,
    seasonHighlighted: seasonHighlighted,
    tabDatas: tabDatas,
    config: config
  };
};
cov_144agggqf5().s[8]++;
var getLoadProductsSuccessAction = function getLoadProductsSuccessAction(data, tabCode, sectionCode, hasMore, sectionCriteria, filterCriteria, filterUpdated, config, generateAllId) {
  cov_144agggqf5().f[4]++;
  cov_144agggqf5().s[9]++;
  return {
    type: _constants.ProductListActionTypes.PRODUCT_LIST_LOAD_PRODUCTS_SUCCESS,
    data: data,
    tabCode: tabCode,
    sectionCode: sectionCode,
    hasMore: hasMore,
    sectionCriteria: sectionCriteria,
    filterCriteria: filterCriteria,
    filterUpdated: filterUpdated,
    config: config,
    generateAllId: generateAllId
  };
};
cov_144agggqf5().s[10]++;
var getChangeFilterAction = function getChangeFilterAction(data) {
  cov_144agggqf5().f[5]++;
  cov_144agggqf5().s[11]++;
  return {
    type: _constants.ProductListActionTypes.PRODUCT_LIST_CHANGE_FILTER_SUCCESS,
    data: data
  };
};
cov_144agggqf5().s[12]++;
var getLoadErrorAction = function getLoadErrorAction() {
  cov_144agggqf5().f[6]++;
  cov_144agggqf5().s[13]++;
  return {
    type: _constants.ProductListActionTypes.PRODUCT_LIST_LOAD_ERROR
  };
};

/**
 *
 * @param {*} config
 * @param {*} tabCode
 */
cov_144agggqf5().s[14]++;
var changeTab = function changeTab(config, tabCode) {
  cov_144agggqf5().f[7]++;
  cov_144agggqf5().s[15]++;
  return function (dispatch) {
    cov_144agggqf5().f[8]++;
    cov_144agggqf5().s[16]++;
    dispatch(getChangeTabAction({
      tabCode: tabCode
    }));
  };
};
cov_144agggqf5().s[17]++;
var hasMore = function hasMore(links) {
  cov_144agggqf5().f[9]++;
  cov_144agggqf5().s[18]++;
  return (cov_144agggqf5().b[0][0]++, links) && (cov_144agggqf5().b[0][1]++, links.next);
};
cov_144agggqf5().s[19]++;
var filterChanged = function filterChanged(filterCriteria) {
  cov_144agggqf5().f[10]++;
  cov_144agggqf5().s[20]++;
  return function (dispatch) {
    cov_144agggqf5().f[11]++;
    cov_144agggqf5().s[21]++;
    dispatch(getChangeFilterAction(filterCriteria));
  };
};
cov_144agggqf5().s[22]++;
var productSelectChanged = function productSelectChanged(tabCode, sectionCode, selectProductId, isSelectAll) {
  cov_144agggqf5().f[12]++;
  cov_144agggqf5().s[23]++;
  return function (dispatch) {
    cov_144agggqf5().f[13]++;
    cov_144agggqf5().s[24]++;
    dispatch({
      type: _constants.ProductListActionTypes.PRODUCT_LIST_SELECT_PRODUCT,
      tabCode: tabCode,
      sectionCode: sectionCode,
      selectProductId: selectProductId,
      isSelectAll: isSelectAll
    });
  };
};
var pendingRequests = (cov_144agggqf5().s[25]++, []);
cov_144agggqf5().s[26]++;
var isPendingRequest = function isPendingRequest(requestUrl) {
  cov_144agggqf5().f[14]++;
  cov_144agggqf5().s[27]++;
  return pendingRequests.indexOf(requestUrl) !== -1;
};
cov_144agggqf5().s[28]++;
var removePendingRequest = function removePendingRequest(requests, requestUrl) {
  cov_144agggqf5().f[15]++;
  var index = (cov_144agggqf5().s[29]++, requests.indexOf(requestUrl));
  cov_144agggqf5().s[30]++;
  if (index === -1) {
    cov_144agggqf5().b[1][0]++;
    cov_144agggqf5().s[31]++;
    return requests;
  } else {
    cov_144agggqf5().b[1][1]++;
  }
  cov_144agggqf5().s[32]++;
  return requests.filter(function (request) {
    cov_144agggqf5().f[16]++;
    cov_144agggqf5().s[33]++;
    return request !== requestUrl;
  });
};
/**
 *
 * @param {*} config
 * @param {*} offset
 * @param {*} limit
 * @param {*} filter
 * @param {*} sectionCriteria
 */
cov_144agggqf5().s[34]++;
var loadProducts = function loadProducts(config, tabCode, sectionCode, offset, limit, sectionCriteria, filter, isFilterChanged) {
  var customSectionDisplay = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : (cov_144agggqf5().b[2][0]++, {});
  cov_144agggqf5().f[17]++;
  cov_144agggqf5().s[35]++;
  return function (dispatch) {
    cov_144agggqf5().f[18]++;
    // PTE TODO in case of FAIRS should pass list of product type per tab && season id
    // Build filter url
    // subTopicId
    // productType
    // productFamily // in case fair
    // seasonId
    var filterCriteria = (cov_144agggqf5().s[36]++, (cov_144agggqf5().b[4][0]++, filter.filterByTab) && (cov_144agggqf5().b[4][1]++, filter.filterByTab[tabCode]) ? (cov_144agggqf5().b[3][0]++, filter.filterByTab[tabCode]) : (cov_144agggqf5().b[3][1]++, []));
    var urlFilterParam = (cov_144agggqf5().s[37]++, (cov_144agggqf5().b[5][0]++, filterCriteria) && (cov_144agggqf5().b[5][1]++, (0, _keys.default)(filterCriteria).reduce(function (acc, filterKey) {
      cov_144agggqf5().f[19]++;
      cov_144agggqf5().s[38]++;
      return filterCriteria[filterKey] ? (cov_144agggqf5().b[6][0]++, "".concat(acc, "&").concat(filterKey, "=").concat(filterCriteria[filterKey])) : (cov_144agggqf5().b[6][1]++, "".concat(acc));
    }, '')));
    var urlSectionParam = (cov_144agggqf5().s[39]++, (0, _keys.default)(sectionCriteria).reduce(function (acc, sectionKey) {
      cov_144agggqf5().f[20]++;
      cov_144agggqf5().s[40]++;
      return sectionCriteria[sectionKey] ? (cov_144agggqf5().b[7][0]++, "".concat(acc, "&").concat(sectionKey, "=").concat(sectionCriteria[sectionKey])) : (cov_144agggqf5().b[7][1]++, '');
    }, ''));
    var customRetrievalUrlPath = (cov_144agggqf5().s[41]++, (0, _get.default)(customSectionDisplay, 'retrievalUrlPath', (cov_144agggqf5().b[9][0]++, config.config) && (cov_144agggqf5().b[9][1]++, config.config.cfcacheEnabled) ? (cov_144agggqf5().b[8][0]++, 'secure/products') : (cov_144agggqf5().b[8][1]++, 'products')));
    var customSectionItemsPath = (cov_144agggqf5().s[42]++, (0, _get.default)(customSectionDisplay, 'itemsPath', 'products'));
    // first dispatch the beforeLoad action
    cov_144agggqf5().s[43]++;
    dispatch(getBeforeLoadProductAction({
      tabCode: tabCode,
      sectionCode: sectionCode,
      sectionCriteria: sectionCriteria,
      filterCriteria: filterCriteria,
      isFilterChanged: isFilterChanged
    }));
    var productOwnerNumberParam = (cov_144agggqf5().s[44]++, config.productOwnerNumber ? (cov_144agggqf5().b[10][0]++, "&productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_144agggqf5().b[10][1]++, ''));
    var urlParams = (cov_144agggqf5().s[45]++, ["?offset=".concat(offset), "&limit=".concat(limit), urlSectionParam, urlFilterParam, productOwnerNumberParam].reduce(function (acc, paramValue) {
      cov_144agggqf5().f[21]++;
      cov_144agggqf5().s[46]++;
      return "".concat(acc).concat(paramValue);
    }, ''));
    var requestUrl = (cov_144agggqf5().s[47]++, "".concat(config.restHost, "/v1/").concat(customRetrievalUrlPath, "/").concat(urlParams));
    cov_144agggqf5().s[48]++;
    if (isPendingRequest(requestUrl)) {
      cov_144agggqf5().b[11][0]++;
      cov_144agggqf5().s[49]++;
      return null;
    } else {
      cov_144agggqf5().b[11][1]++;
    }
    cov_144agggqf5().s[50]++;
    pendingRequests.push(requestUrl);
    cov_144agggqf5().s[51]++;
    return (0, _gAxios.default)(requestUrl, {
      headers: config.headers
    }).then(function (response) {
      cov_144agggqf5().f[22]++;
      cov_144agggqf5().s[52]++;
      pendingRequests = removePendingRequest(pendingRequests, requestUrl);
      cov_144agggqf5().s[53]++;
      if ((cov_144agggqf5().b[13][0]++, response.status >= 200) && (cov_144agggqf5().b[13][1]++, response.status < 300)) {
        cov_144agggqf5().b[12][0]++;
        var links = (cov_144agggqf5().s[54]++, (0, _helper.default)(response.headers.links));
        var generateAllId = (cov_144agggqf5().s[55]++, response.data.generateAllId !== 0 ? (cov_144agggqf5().b[14][0]++, response.data.generateAllId) : (cov_144agggqf5().b[14][1]++, null));
        cov_144agggqf5().s[56]++;
        dispatch(getLoadProductsSuccessAction((0, _get.default)(response.data, customSectionItemsPath, []), tabCode, sectionCode, hasMore(links), sectionCriteria, filterCriteria, isFilterChanged, config, generateAllId));
        cov_144agggqf5().s[57]++;
        return response.data;
      } else {
        cov_144agggqf5().b[12][1]++;
      }
      cov_144agggqf5().s[58]++;
      throw response;
    }).catch(function (response) {
      cov_144agggqf5().f[23]++;
      cov_144agggqf5().s[59]++;
      pendingRequests = removePendingRequest(pendingRequests, requestUrl);
      cov_144agggqf5().s[60]++;
      dispatch(getLoadErrorAction());
      cov_144agggqf5().s[61]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_144agggqf5().s[62]++;
      return response;
    });
  };
};
cov_144agggqf5().s[63]++;
var loadTabs = function loadTabs(config, tabDatas, layoutOptions) {
  cov_144agggqf5().f[24]++;
  cov_144agggqf5().s[64]++;
  return function (dispatch) {
    cov_144agggqf5().f[25]++;
    cov_144agggqf5().s[65]++;
    // first dispatch the beforeLoad action
    dispatch(getBeforeLoadSummaryAction());
    // then fetch the catalog summary
    var urlPath = (cov_144agggqf5().s[66]++, "".concat(config.restHost, "/v1/").concat((cov_144agggqf5().b[16][0]++, config.config) && (cov_144agggqf5().b[16][1]++, config.config.cfcacheEnabled) ? (cov_144agggqf5().b[15][0]++, 'secure/') : (cov_144agggqf5().b[15][1]++, ''), "catalog/summary").concat(config.productOwnerNumber ? (cov_144agggqf5().b[17][0]++, "?productOwnerNumber=".concat(config.productOwnerNumber)) : (cov_144agggqf5().b[17][1]++, '')));
    cov_144agggqf5().s[67]++;
    if ((cov_144agggqf5().b[19][0]++, config.config) && (cov_144agggqf5().b[19][1]++, config.config.cachedCatalogEnabled)) {
      cov_144agggqf5().b[18][0]++;
      cov_144agggqf5().s[68]++;
      urlPath = "".concat(config.restHost, "/v1/catalog/summary/shared");
    } else {
      cov_144agggqf5().b[18][1]++;
    }
    cov_144agggqf5().s[69]++;
    return (0, _gAxios.default)(urlPath, {
      headers: config.headers
    }).then(function (response) {
      cov_144agggqf5().f[26]++;
      cov_144agggqf5().s[70]++;
      if ((cov_144agggqf5().b[21][0]++, response.status >= 200) && (cov_144agggqf5().b[21][1]++, response.status < 300)) {
        cov_144agggqf5().b[20][0]++;
        cov_144agggqf5().s[71]++;
        dispatch(getLoadSummarySuccessAction(response.data, layoutOptions, config.seasonHighlighted, tabDatas, config));
        cov_144agggqf5().s[72]++;
        return response.data;
      } else {
        cov_144agggqf5().b[20][1]++;
      }
      cov_144agggqf5().s[73]++;
      throw response;
    }).catch(function (response) {
      cov_144agggqf5().f[27]++;
      cov_144agggqf5().s[74]++;
      dispatch(getLoadErrorAction());
      cov_144agggqf5().s[75]++;
      (0, _gAxios.logError)((0, _gAxios.getFrontEndErrorFromAxiosError)(response), config.headers, config.widgetInfo, response);
      cov_144agggqf5().s[76]++;
      return response;
    });
  };
};
var _default = exports.default = {
  loadProducts: loadProducts,
  loadTabs: loadTabs,
  changeTab: changeTab,
  filterChanged: filterChanged,
  productSelectChanged: productSelectChanged
};